export const version = 'kunde-b7c4678cc55124876c52730526ba5d101837a7bc';